const getWeekDay = (date) => {
    // Returns number of the week day (0-6 for mon-sun)
    return date.getDay();
};
const getMonth = (date) => {
    return date.getMonth();
};
const getDate = (date) => {
    return date.getDate();
};
const getMonthName = (date, language) => {
    return date.toLocaleString(language, { month: 'long' });
};
const getYear = (date) => {
    return date.getFullYear();
};
/**
 * Compares dates. Checks if date1 is before date2.
 * @param date1 Date
 * @param date2 Date
 */
const isBeforeDate = (date1, date2) => {
    const newDate1 = new Date(getYear(date1), getMonth(date1), getDate(date1), 0, 0, 0);
    const newDate2 = new Date(getYear(date2), getMonth(date2), getDate(date2), 0, 0, 0);
    return newDate2 < newDate1;
};
/**
 * Compares dates. Checks if date2 is after date1.
 * @param date1 Date
 * @param date2 Date
 */
const isAfterDate = (date1, date2) => {
    const newDate1 = new Date(getYear(date1), getMonth(date1), getDate(date1), 0, 0, 0);
    const newDate2 = new Date(getYear(date2), getMonth(date2), getDate(date2), 0, 0, 0);
    return newDate2 > newDate1;
};
const extractRangeDate = (dateValue) => {
    if (dateValue) {
        const [date, rangeDate] = dateValue.split('/').map((part) => part.trim());
        return {
            date: date,
            rangeDate: (rangeDate === null || rangeDate === void 0 ? void 0 : rangeDate.length) > 1 ? rangeDate : undefined,
        };
    }
};
const isDateBetweenRange = (date, startDate, endDate) => {
    return isAfterDate(startDate, date) && isBeforeDate(endDate, date);
};
const getTrimmedDate = (value) => {
    return value
        .trim()
        .split(',')
        .map((date) => new Date(createDateFromParts(date)));
};
const extractDateParts = (dateString) => {
    const [year, month, day] = dateString.split(/[-T]/).map(Number);
    return { year, month, day };
};
const createDateFromParts = (date) => {
    return new Date(extractDateParts(date).year, extractDateParts(date).month - 1, extractDateParts(date).day);
};
/**
 * Converts a given date to a local ISO string representation.
 * @param date - The date to convert.
 * @returns The local ISO string representation of the date.
 */
const toLocalISOString = (date) => {
    var _a;
    if (!date || isNaN(date.getTime()))
        return;
    const timezoneOffset = date.getTimezoneOffset() * 60000;
    const localISOTime = (_a = (new Date(date.getTime() - timezoneOffset))) === null || _a === void 0 ? void 0 : _a.toISOString();
    return localISOTime;
};

export { isAfterDate as a, isDateBetweenRange as b, getMonth as c, getWeekDay as d, extractRangeDate as e, getMonthName as f, getTrimmedDate as g, getYear as h, isBeforeDate as i, createDateFromParts as j, toLocalISOString as t };
